var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMouthC(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 6,
    viewBox: "0 0 43 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0403824 5.18906C0.196175 5.78523 0.757484 6.12822 1.2941 5.95514C9.08244 3.44305 16.1781 2.23445 22.3083 2.24821C28.4417 2.26197 33.6679 3.49946 41.7197 5.95947C42.2585 6.12408 42.8154 5.77228 42.9635 5.17371C43.1117 4.57514 42.795 3.95646 42.2563 3.79185C34.1201 1.30607 28.6993 0.0144558 22.3123 0.00012064C15.922 -0.0142217 8.62375 1.25008 0.729928 3.79619C0.19331 3.96927 -0.11541 4.59288 0.0403824 5.18906Z",
    fill: "#181111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouthC);
export default __webpack_public_path__ + "static/media/Mouth C.a45f5b177f8cabd5cd7b1d75a8fa831c.svg";
export { ForwardRef as ReactComponent };